import { render, staticRenderFns } from "./beethoven-attachment-caption.vue?vue&type=template&id=747a5e41&"
import script from "./beethoven-attachment-caption.vue?vue&type=script&lang=ts&"
export * from "./beethoven-attachment-caption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports